import React, { Component } from 'react';
import ReactDOM from 'react-dom';
let Components = {};
Components['truck'] = require('../components/layouts/truckSidebarComponent').default;
Components['transporter'] = require('../components/layouts/transporterSidebarComponent').default;
Components['lsp'] = require('../components/layouts/lspSidebarComponent').default;
Components['consignment'] = require('../components/layouts/consignmentSidebarComponent').default;
Components['activeTrucks'] = require('../components/layouts/activeTrucksSideBar').default;
export default Components;